// // src\themes\tolica\elements\Header\HeaderShell.tsx
// "use client"

// import { useEffect, useState } from "react"

// export default function HeaderShell({ children }: { children: React.ReactNode }) {
//     const [scrolled, setScrolled] = useState(false)

//     useEffect(() => {
//         const onScroll = () => setScrolled(window.scrollY > 20)
//         window.addEventListener("scroll", onScroll, { passive: true })
//         return () => window.removeEventListener("scroll", onScroll)
//     }, [])

//     return (
//         <header
//             className={`
//         m-auto sticky top-0 z-50 print:hidden
//         flex items-center justify-between
//         px-4 sm:px-6 lg:px-12
//         transition-all duration-300 ease-out bg-neutral-950/90
//         ${scrolled
//                     ? "h-14 shadow-lg shadow-primary-900/5"
//                     : "h-20 "
//                 }
//       `}
//             data-scrolled={scrolled}
//         >
//             {children}
//         </header>
//     )
// }


// src\themes\tolica\elements\Header\HeaderShell.tsx
"use client"

import { useHeaderScrolled } from "@/core/hooks/use-header-scrolled"
import { useIsHome } from "@/core/hooks/use-is-home"
import { useMegaMenuStore } from "@/stores/megaMenuStore"
import { cn } from "@/core/lib/utils"

export default function HeaderShell({ children }: { children: React.ReactNode }) {
    const scrolled = useHeaderScrolled()
    const isHome = useIsHome()
    const isMegaMenuOpen = useMegaMenuStore(s => s.isOpen)

    // فقط توی صفحه‌ی اصلی و قبل از اسکرول، هدر شفافه (تا بنر/هیروی زیرش دیده بشه)؛
    // همون رفتار هدر تم ارم. بقیه‌ی صفحات، بعد از اسکرول، یا وقتی مگامنو باز
    // شده (که خودش پنل تیره داره و باید با نوار هدر یکدست به‌نظر برسه)، همیشه
    // حالت تیره‌ی نیمه‌شفاف همیشگی رو داره
    const isTransparent = isHome && !scrolled && !isMegaMenuOpen

    return (
        <header
            className={cn(
                "group/header fixed top-0 inset-x-0 z-50 print:hidden",
                "flex items-center justify-between",
                "px-4 sm:px-6 lg:px-12",
                "transition-all duration-300 ease-out",
                scrolled ? "h-14 shadow-lg shadow-primary-900/5" : "h-20",
                isTransparent ? "bg-transparent" : "bg-neutral-950/90 backdrop-blur-sm"
            )}
            data-scrolled={scrolled}
        >
            {isHome && (
                <div
                    aria-hidden
                    className={cn(
                        "pointer-events-none absolute top-0 inset-x-0 h-64 -z-10",
                        "bg-gradient-to-b from-black/55 via-black/25 to-transparent",
                        "transition-opacity duration-300",
                        scrolled ? "opacity-0" : "opacity-100"
                    )}
                />
            )}
            {children}
        </header>
    )
}